import React from 'react'
import { useDispatch } from 'react-redux'
import { updateParty } from '../../firebase-services/db-services'
import { getPartiesFetch } from '../../Redux/slices/partyState'
import handleChange from '../../Utils/HandleChange'
import { FormInput, FormRow } from '../Controls/Input'
import {  toast } from 'react-toastify';

export default function UpdateParty({ formData,setFormData }) {
  const dispatch = useDispatch()
    const changeHandler = handleChange(formData, setFormData)
    const submitHandler = (e) => {
        e.preventDefault()
        updateParty(formData.docid,formData).then(res=>{
            dispatch(getPartiesFetch())
            toast.success("Party Details Updated")
            //ScrollToTargetAdjusted('transactionTable')
          }).catch(e=>{
            toast.error("Failed to update Party Details")
            console.log(e)})
        
    }
  return (
    <div id='updatePartyForm' className="bg-gray-100 p-8 rounded-md mx-auto my-36 w-full max-w-7xl">
    <form className='w-full'>
      <h1 className='text-2xl sm:text-3xl md:text-4xl font-bold tracking-wide mb-7'>Update Party Details</h1>
      <FormRow mx={3}>
        <FormInput name='name' type="text" label='Party Name' onChange={changeHandler} placeholder={"Party Name"} value={formData.name}  />
        <FormInput name='firm' type='text' label='Firm Name' placeholder='Party Firm Name' onChange={changeHandler} value={formData.firm} />
      </FormRow>
      <FormRow mx={3}>
        <FormInput name='mobile' type='text' label='Mobile No.' placeholder='9756721202' onChange={changeHandler}value={formData.mobile}  />
        <FormInput name='address' label='Address' onChange={changeHandler} placeholder="Party Address" value={formData.address} />
      </FormRow>

      <div className='flex flex-row gap-4'>
        <button
          className="hover:bg-[#4f48ee] rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
          onClick={submitHandler}
        >
          Submit
        </button>
        <input type="reset"
          className="hover:bg-gray-600 cursor-pointer rounded-md bg-gray-500 py-3 px-8 text-center text-base font-semibold text-white outline-none"
        />
      </div>
    </form>
  </div>
  )
}
